<script>
import { watch } from 'vue'
import { notificación } from '@/../../cliente_comun/utilidades'
import { ubicaciónDePuntoDeVenta, inicializarServicioDeGuardado, establecerDatos, limpiarObjeto } from '@/../../cliente_comun/fuentes_puntosDeVenta_ubicaciones.js'

export default {
	props: {
		identificadorDePuntoDeVenta: String,
		datos: Object,
	},
	beforeDestroy() {
		limpiarObjeto()
	},
	setup(props, { emit }) {
		limpiarObjeto()
		if (props.datos) {
			establecerDatos(props.datos)
		}

		const servicioDeGuardado = inicializarServicioDeGuardado(props.identificadorDePuntoDeVenta)

		watch(() => props.datos, () => {
			if (!props.identificadorDePuntoDeVenta) {
				notificación.error('[3265874435] Ocurrió un error inesperado.')
				return
			}

			if (props.datos) {
				establecerDatos(props.datos)
			} else {
				limpiarObjeto()
			}
		})

		async function guardarUbicaciónDePuntoDeVenta() {
			const msj = 'Ubicación guardada.'
			if (props.datos) {
				await servicioDeGuardado.editar(props.datos.identificador, ubicaciónDePuntoDeVenta, msj)
			} else {
				await servicioDeGuardado.crear(ubicaciónDePuntoDeVenta, msj)
			}
			emit('guardar', true)
		}

		return {
			ubicaciónDePuntoDeVenta,
			servicioDeGuardado,
			guardarUbicaciónDePuntoDeVenta,
			emit,
		}
    }
}

</script>

<template>
	<v-card>
		<v-card-title class="headline">Ubicación de punto de venta</v-card-title>
		<v-card-text>
			<v-text-field
				v-model="ubicaciónDePuntoDeVenta.nombre"
				maxlength="100"
				label="Nombre"
				required
			></v-text-field>
			<v-text-field
				v-model="ubicaciónDePuntoDeVenta.descripción"
				maxlength="500"
				label="Descripción"
				required
			></v-text-field>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>

			<v-btn
				color="grey darken-1"
				text
				:disabled="servicioDeGuardado.guardando.value"
				@click="emit('cancelar', true)"
			>
				Cancelar
			</v-btn>

			<v-btn
				color="green darken-1"
				text
				:loading="servicioDeGuardado.guardando.value"
				@click="guardarUbicaciónDePuntoDeVenta()"
			>
				Guardar
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
